import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import {
  Card,
  CardBody,
  CardTitle,
} from 'reactstrap';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { Loading } from '../../../loadbar/Loading';
import { SingleResultGrid } from '../../../grid/SingleResultGrid';
import { Column } from '../../../grid/Column';
import { RunupDataGrid } from '../../hazards/tsunamis/runups/data/RunupDataGrid';
import { isDataManager } from '../../../../role/roleUtils';
import {
  clearReferenceInfo as clearReferenceInfoAc,
  getReference as getReferenceAc,
  getVolcanoes as getVolcanoesAc,
  getEarthquakes as getEarthquakesAc,
  getTsunamis as getTsunamisAc,
  getRunups as getRunupsAc,
  sortVolcanoes as sortVolcanoesAc,
  sortEarthquakes as sortEarthquakesAc,
  sortTsunamis as sortTsunamisAc,
  sortRunups as sortRunupsAc,
  deleteVolcano as deleteVolcanoAc,
  deleteEarthquake as deleteEarthquakeAc,
  deleteTsunami as deleteTsunamiAc,
  deleteRunup as deleteRunupAc,
  toggleVolcanoColumns as toggleVolcanoColumnsAc,
  toggleEarthquakeColumns as toggleEarthquakeColumnsAc,
  toggleTsunamiColumns as toggleTsunamiColumnsAc,
  toggleRunupColumns as toggleRunupColumnsAc,
} from '../../../../redux/references/info/referenceInfoActions';
import { withUser } from '../../../auth/withUser';
import { RawHtml } from '../../../form/RawHtml';
import { TsunamiDataGrid } from '../../hazards/tsunamis/events/data/TsunamiDataGrid';
import { EarthquakeDataGrid } from '../../hazards/earthquakes/data/EarthquakeDataGrid';
import { VolcanoEventDataGrid } from '../../hazards/volcanoes/events/data/VolcanoEventDataGrid';

class ReferenceInfoPageUnwrapped extends Component {
  constructor(props) {
    super(props);
    this.loadReferencedHazards = this.loadReferencedHazards.bind(this);
  }

  loadReferencedHazards() {
    const {
      match: { params },
      getTsunamis,
      getEarthquakes,
      getRunups,
      getVolcanoes,
    } = this.props;
    getTsunamis({ id: params.id });
    getEarthquakes({ id: params.id });
    getRunups({ id: params.id });
    getVolcanoes({ id: params.id });
  }

  componentDidMount() {
    document.title = 'NCEI Hazard Reference Information';
    const {
      match: { params },
      getReference,
      clearReferenceInfo,
      authorities,
    } = this.props;
    const dataManager = isDataManager(authorities);
    clearReferenceInfo();
    if (dataManager) {
      this.loadReferencedHazards();
    }
    getReference({ id: params.id });
  }

  componentDidUpdate(prevProps) {
    const {
      authorities: prevAuthorities,
    } = prevProps;
    const {
      authorities,
    } = this.props;
    const wasDataManager = isDataManager(prevAuthorities);
    const dataManager = isDataManager(authorities);
    if (!wasDataManager && dataManager) {
      this.loadReferencedHazards();
    }
  }

  componentWillUnmount() {
    const { clearReferenceInfo } = this.props;
    clearReferenceInfo();
  }

  render() {
    const {
      history,
      fetched,
      authorities,
      reference,
      volcanoes,
      earthquakes,
      tsunamis,
      runups,
      sortVolcanoes,
      sortRunups,
      runupSort,
      deletingRunup,
      deleteRunup,
      getRunups,
      visibleRunupColumns,
      toggleRunupColumns,
      sortTsunamis,
      tsunamiSort,
      visibleTsunamiColumns,
      toggleTsunamiColumns,
      deletingTsunami,
      deleteTsunami,
      getTsunamis,
      sortEarthquakes,
      earthquakeSort,
      visibleEarthquakeColumns,
      toggleEarthquakeColumns,
      deletingEarthquake,
      deleteEarthquake,
      getEarthquakes,
      volcanoSort,
      visibleVolcanoColumns,
      toggleVolcanoColumns,
      deletingVolcano,
      deleteVolcano,
      getVolcanoes,
    } = this.props;

    if (!fetched) {
      return (<Loading />);
    }

    const dataManager = isDataManager(authorities);

    const searchParams = `Reference ID = ${reference.get('id')}`;

    return (
      <div className="haz-info-container haz-page-container">

        <div className="haz-info-content">
          <div className="haz-info-content-section">
            <Card>
              <CardBody>
                <CardTitle tag="h1">Reference Information</CardTitle>
                <SingleResultGrid data={reference}>
                  {dataManager && (<Column id="id" width={100}>Id</Column>)}
                  {dataManager && (<Column id="publish" cell={({ value }) => (value ? 'Y' : 'N')} width={100}>Publish</Column>)}
                  <Column id="author" width={200}>Author</Column>
                  <Column id="year" width={100}>Year</Column>
                  <Column id="citation" width={300} cell={({ value }) => (<RawHtml>{value}</RawHtml>)}>Citation</Column>
                  {dataManager && (<Column id="ok" width={90}>Ok</Column>)}
                  {dataManager && (<Column id="have" width={100}>Have</Column>)}
                  {dataManager && (<Column id="comments" width={300}>Comments</Column>)}
                </SingleResultGrid>
              </CardBody>
            </Card>
          </div>

          {dataManager && (
          <div className="haz-info-content-section">
            <Card>
              <CardBody>
                <CardTitle tag="h2">{`Referenced Volcano Events - ${volcanoes.size} Results Found`}</CardTitle>
                <VolcanoEventDataGrid
                  volcanoEvents={volcanoes}
                  dataManager={dataManager}
                  sortData={sortVolcanoes}
                  sort={volcanoSort}
                  visibleColumns={visibleVolcanoColumns}
                  toggleColumns={toggleVolcanoColumns}
                  searchParams={searchParams}
                  deleting={deletingVolcano}
                  deleteVolcanoEvent={deleteVolcano}
                  history={history}
                  onDeleteCloseModal={getVolcanoes}
                />
              </CardBody>
            </Card>
          </div>
          )}


          {dataManager && (
          <div className="haz-info-content-section">
            <Card>
              <CardBody>
                <CardTitle tag="h2">{`Referenced Earthquakes - ${earthquakes.size} Results Found`}</CardTitle>
                <EarthquakeDataGrid
                  earthquakes={earthquakes}
                  dataManager={dataManager}
                  sortData={sortEarthquakes}
                  sort={earthquakeSort}
                  visibleColumns={visibleEarthquakeColumns}
                  toggleColumns={toggleEarthquakeColumns}
                  searchParams={searchParams}
                  deleting={deletingEarthquake}
                  deleteEarthquake={deleteEarthquake}
                  history={history}
                  onDeleteCloseModal={getEarthquakes}
                />
              </CardBody>
            </Card>
          </div>
          )}

          {dataManager && (
          <div className="haz-info-content-section">
            <Card>
              <CardBody>
                <CardTitle tag="h2">{`Referenced Tsunamis - ${tsunamis.size} Results Found`}</CardTitle>
                <TsunamiDataGrid
                  tsunamiEvents={tsunamis}
                  dataManager={dataManager}
                  sortData={sortTsunamis}
                  sort={tsunamiSort}
                  visibleColumns={visibleTsunamiColumns}
                  toggleColumns={toggleTsunamiColumns}
                  searchParams={searchParams}
                  deleting={deletingTsunami}
                  deleteTsunami={deleteTsunami}
                  onDeleteCloseModal={getTsunamis}
                />
              </CardBody>
            </Card>
          </div>
          )}

          {dataManager && (
          <div className="haz-info-content-section">
            <Card>
              <CardBody>
                <CardTitle tag="h2">{`Referenced Runups - ${runups.size} Results Found`}</CardTitle>
                <RunupDataGrid
                  runups={runups}
                  dataManager={dataManager}
                  sortData={sortRunups}
                  sort={runupSort}
                  visibleColumns={visibleRunupColumns}
                  toggleColumns={toggleRunupColumns}
                  searchParams={searchParams}
                  deleting={deletingRunup}
                  deleteRunup={deleteRunup}
                  onDeleteCloseModal={getRunups}
                />
              </CardBody>
            </Card>
          </div>
          )}
        </div>

      </div>
    );
  }
}


ReferenceInfoPageUnwrapped.propTypes = {
  match: PropTypes.shape({ params: PropTypes.shape({ id: PropTypes.string }) }).isRequired,
  history: PropTypes.shape({}).isRequired,
  authorities: ImmutablePropTypes.list.isRequired,
  fetched: PropTypes.bool.isRequired,
  reference: ImmutablePropTypes.map.isRequired,
  volcanoes: ImmutablePropTypes.list.isRequired,
  tsunamis: ImmutablePropTypes.list.isRequired,
  runups: ImmutablePropTypes.list.isRequired,
  earthquakes: ImmutablePropTypes.list.isRequired,

  volcanoSort: ImmutablePropTypes.list.isRequired,
  earthquakeSort: ImmutablePropTypes.list.isRequired,
  tsunamiSort: ImmutablePropTypes.list.isRequired,
  runupSort: ImmutablePropTypes.list.isRequired,

  deletingVolcano: PropTypes.bool.isRequired,
  deletingEarthquake: PropTypes.bool.isRequired,
  deletingTsunami: PropTypes.bool.isRequired,
  deletingRunup: PropTypes.bool.isRequired,

  visibleVolcanoColumns: ImmutablePropTypes.list.isRequired,
  visibleEarthquakeColumns: ImmutablePropTypes.list.isRequired,
  visibleTsunamiColumns: ImmutablePropTypes.list.isRequired,
  visibleRunupColumns: ImmutablePropTypes.list.isRequired,

  clearReferenceInfo: PropTypes.func.isRequired,
  getReference: PropTypes.func.isRequired,
  getVolcanoes: PropTypes.func.isRequired,
  getEarthquakes: PropTypes.func.isRequired,
  getTsunamis: PropTypes.func.isRequired,
  getRunups: PropTypes.func.isRequired,

  deleteVolcano: PropTypes.func.isRequired,
  deleteEarthquake: PropTypes.func.isRequired,
  deleteTsunami: PropTypes.func.isRequired,
  deleteRunup: PropTypes.func.isRequired,

  sortVolcanoes: PropTypes.func.isRequired,
  sortEarthquakes: PropTypes.func.isRequired,
  sortTsunamis: PropTypes.func.isRequired,
  sortRunups: PropTypes.func.isRequired,

  toggleVolcanoColumns: PropTypes.func.isRequired,
  toggleEarthquakeColumns: PropTypes.func.isRequired,
  toggleTsunamiColumns: PropTypes.func.isRequired,
  toggleRunupColumns: PropTypes.func.isRequired,

};

const mapStateToProps = (state, props) => {
  const { authorities } = props;
  const dataManager = isDataManager(authorities);
  const fetchedReference = state.getIn(['referenceInfoPage', 'fetchedReference']);
  const fetchedVolcanoes = !dataManager || state.getIn(['referenceInfoPage', 'fetchedVolcanoes']);
  const fetchedEarthquakes = !dataManager || state.getIn(['referenceInfoPage', 'fetchedEarthquakes']);
  const fetchedTsunamis = !dataManager || state.getIn(['referenceInfoPage', 'fetchedTsunamis']);
  const fetchedRunups = !dataManager || state.getIn(['referenceInfoPage', 'fetchedRunups']);
  return {
    fetched: [
      fetchedReference,
      fetchedVolcanoes,
      fetchedEarthquakes,
      fetchedTsunamis,
      fetchedRunups,
    ].every(v => v),
    reference: state.getIn(['referenceInfoPage', 'reference']),
    volcanoes: state.getIn(['referenceInfoPage', 'volcanoes']),
    tsunamis: state.getIn(['referenceInfoPage', 'tsunamis']),
    runups: state.getIn(['referenceInfoPage', 'runups']),
    earthquakes: state.getIn(['referenceInfoPage', 'earthquakes']),
    volcanoSort: state.getIn(['referenceInfoPage', 'volcanoSort']),
    earthquakeSort: state.getIn(['referenceInfoPage', 'earthquakeSort']),
    tsunamiSort: state.getIn(['referenceInfoPage', 'tsunamiSort']),
    runupSort: state.getIn(['referenceInfoPage', 'runupSort']),
    deletingVolcano: state.getIn(['referenceInfoPage', 'deletingVolcano']),
    deletingEarthquake: state.getIn(['referenceInfoPage', 'deletingEarthquake']),
    deletingTsunami: state.getIn(['referenceInfoPage', 'deletingTsunami']),
    deletingRunup: state.getIn(['referenceInfoPage', 'deletingRunup']),
    visibleVolcanoColumns: state.getIn(['referenceInfoPage', 'visibleVolcanoColumns']),
    visibleEarthquakeColumns: state.getIn(['referenceInfoPage', 'visibleEarthquakeColumns']),
    visibleTsunamiColumns: state.getIn(['referenceInfoPage', 'visibleTsunamiColumns']),
    visibleRunupColumns: state.getIn(['referenceInfoPage', 'visibleRunupColumns']),
  };
};

const mapDispatchToProps = dispatch => bindActionCreators({
  clearReferenceInfo: clearReferenceInfoAc,
  getReference: getReferenceAc,
  getVolcanoes: getVolcanoesAc,
  getEarthquakes: getEarthquakesAc,
  getTsunamis: getTsunamisAc,
  getRunups: getRunupsAc,
  sortVolcanoes: sortVolcanoesAc,
  sortEarthquakes: sortEarthquakesAc,
  sortTsunamis: sortTsunamisAc,
  sortRunups: sortRunupsAc,
  deleteVolcano: deleteVolcanoAc,
  deleteEarthquake: deleteEarthquakeAc,
  deleteTsunami: deleteTsunamiAc,
  deleteRunup: deleteRunupAc,
  toggleVolcanoColumns: toggleVolcanoColumnsAc,
  toggleEarthquakeColumns: toggleEarthquakeColumnsAc,
  toggleTsunamiColumns: toggleTsunamiColumnsAc,
  toggleRunupColumns: toggleRunupColumnsAc,
}, dispatch);

export const ReferenceInfoPage = withUser(connect(mapStateToProps, mapDispatchToProps)(ReferenceInfoPageUnwrapped));
